import { useQuery } from '@tanstack/react-query'
import { getAsync } from '@/helpers/http-request'

type ErrorData = {
  error: string;
  description?: string;
}

const useErrorDetails = (errorId: string | null) => {
  const { data, isLoading } = useQuery({
    queryKey: ['error', errorId],
    queryFn: async (): Promise<ErrorData | null> => {
      const res = await getAsync(`/web/v1/user/explainError?errorId=${errorId}`);
      return res.ok ? res.json() : null;
    },
    enabled: !!errorId,
  });

  return { error: data, isLoading };
}
export default useErrorDetails;